"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EQBar = exports.calculatePercentage = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importStar(require("@travelnest/merlin.theme"));
const React = __importStar(require("react"));
const calculatePercentage = (value, minValue, maxValue) => {
    // Calculate percentage, constraining value to floor and ceiling if outwith the range
    value = Math.max(Math.min(value, maxValue), minValue);
    return Math.trunc((value - minValue) / (maxValue - minValue) * 100);
};
exports.calculatePercentage = calculatePercentage;
const StyleWrapper = styled_1.default.div `
height: ${(props) => props.height};
width: ${(props) => props.width};
position: relative;
max-width: 60px;

.eq-bar__bar {
    width: 33%;
    height: 90%;
    border-radius: 30px;
    position: absolute;
    left: calc(50% - (33% / 2));
    background: ${merlin_theme_1.palette.greyscale.light};
    z-index: 1;
}

.eq-bar__percentage-marker {
    position: absolute;
    background: ${merlin_theme_1.default.colours.primary.default};
    height: 8px;
    /* Aligns the middle of the marker to the bar */
    width: 280%;
    left: -90%;
    border-radius: 30px;
    z-index: 3;
	transition: 0.3s bottom;
	bottom: ${(props) => `calc(${props.percentage}% - (8px / 2))`}
}

.eq-bar__bar .eq-bar__midpoint {
    position: absolute;
    bottom: calc(50% + 2px);
    border: none;
    margin: 0;
    /* Aligns the middle of the marker to the bar */
    width: 280%;
    left: -90%;
    border-bottom: 2px solid ${merlin_theme_1.palette.greyscale.medium};
    z-index: 1;
}

.eq-bar__name {
    height: 10%;
    width: 100%;
    top: 90%;
    position: absolute;
    margin-top: 5px;
    text-align: center;
    font-size: 0.8em;
}
`;
const EQBar = (props) => {
    let displayPercentage = 50;
    if (typeof props.min === 'number' &&
        typeof props.max === 'number' &&
        typeof props.value === 'number') {
        displayPercentage = (0, exports.calculatePercentage)(props.value, props.min, props.max);
    }
    if (typeof props.percentage === 'number') {
        displayPercentage = props.percentage;
    }
    return React.createElement(StyleWrapper, { height: props.height, width: props.width, percentage: displayPercentage, "data-testid": "eq-bar" },
        React.createElement("div", { className: "eq-bar__bar" },
            React.createElement("div", { className: "eq-bar__percentage-marker", "data-testid": "eq-bar-percentage" }),
            React.createElement("hr", { className: "eq-bar__midpoint" })),
        React.createElement("div", { className: "eq-bar__name" },
            React.createElement("span", null, props.name)));
};
exports.EQBar = EQBar;
//# sourceMappingURL=EQBar.js.map